import { createContext } from "react";

const organisationContext = createContext();

export default organisationContext;